import { ViewCommon } from "components/index";
import styled from "styled-components";
import { mediaScreen, spacing } from "theme";
import { metric } from "theme";

export const Container = styled(ViewCommon)`
  overflow-x: hidden;
  overflow-y: hidden;
`;